import { Roles } from "../config/role-config.json";
import RMEquipmentsPage from "../pages/RegionalManager/RMEquipmentsPage";
import RMEquipmentForm from "../pages/RegionalManager/RMEquipmentForm";
import RMTraysPage from "../pages/RegionalManager/RMTraysPage";
import RMTrayForm from "../pages/RegionalManager/RMTrayForm";
import RMProcedureForm from "../pages/RegionalManager/RMProcedureForm";
import RMProceduresPage from "../pages/RegionalManager/RMProceduresPage";
import ExecutionFlow from "../shared-pages/read-only/mini-app/ExecutionFlow";
import ProcedureMainPage from "../shared-pages/read-only/mini-app/ProcedureMainPage";
import MedicalRepresentativeForm from "../pages/RegionalManager/MedicalRepresentativeForm";
import MedicalRepresentativesPage from "../pages/RegionalManager/MedicalRepresentativesPage";
import RegionalManagerForm from "../pages/Area/RegionalManagerForm";
import CaseForm from "../shared-pages/read-only/hospital-and-cases/CasesForm";
import LiveCaseMainPage from "../shared-pages/read-only/mini-app/LiveCaseMainPage";
import RMHospitalsCasePage from "../pages/RegionalManager/RMHospitalsCasePage";
import RMHospitalsPage from "../pages/RegionalManager/RMHospitalsPage";
import RMTableSetup from "../pages/RegionalManager/RMTableSetup";
import RMTrayEquipmentPage from "../pages/RegionalManager/RMTrayEquipmentPage";
import RMExecutionFlowPage from "../pages/RegionalManager/RMExecutionFlowPage";
import { BreadCrumbData } from "./index.routes";

const regionalManagerRoutes = {
  Routes: [
    {
      path: "/manufacturer/:id/area/:areaid/regional-manager/:rmid/setup",
      rolesAccess: [
        Roles.DOR_ADMIN,
        Roles.MANUFACTURER_ADMIN,
        Roles.AREA_MANAGER,
        Roles.REGIONAL_MANAGER,
      ],
      exact: true,
      component: RegionalManagerForm,
    },
    /** ReadOnly Hospital and Cases */
    //for breadcrumbs
    {
      path: "/manufacturer/:id/area/:areaid/regional-manager/:rmid/hospital/:hospitalid",
      rolesAccess: [
        Roles.DOR_ADMIN,
        Roles.MANUFACTURER_ADMIN,
        Roles.AREA_MANAGER,
        Roles.REGIONAL_MANAGER,
      ],
      exact: true,
      breadcrumb: (props) => (
        <BreadCrumbData type="hospital" id={props.match.params.hospitalid} />
      ),
      redirection: "case",
    },
    {
      path: "/manufacturer/:id/area/:areaid/regional-manager/:rmid/hospital/:hospitalid/case/completed",
      rolesAccess: [
        Roles.DOR_ADMIN,
        Roles.MANUFACTURER_ADMIN,
        Roles.AREA_MANAGER,
        Roles.REGIONAL_MANAGER,
      ],
      exact: true,
      breadcrumb: "Completed",
      component: RMHospitalsCasePage,
    },
    {
      path: "/manufacturer/:id/area/:areaid/regional-manager/:rmid/hospital/:hospitalid/case/deleted",
      rolesAccess: [
        Roles.DOR_ADMIN,
        Roles.MANUFACTURER_ADMIN,
        Roles.AREA_MANAGER,
        Roles.REGIONAL_MANAGER,
      ],
      exact: true,
      breadcrumb: "Deleted",
      component: RMHospitalsCasePage,
    },
    {
      path: "/manufacturer/:id/area/:areaid/regional-manager/:rmid/hospital/:hospitalid/case/:caseid",
      rolesAccess: [
        Roles.DOR_ADMIN,
        Roles.MANUFACTURER_ADMIN,
        Roles.AREA_MANAGER,
        Roles.REGIONAL_MANAGER,
      ],
      exact: true,
      breadcrumb: "Case Details",
      component: CaseForm,
    },
    {
      path: "/manufacturer/:id/area/:areaid/regional-manager/:rmid/hospital/:hospitalid/case",
      rolesAccess: [
        Roles.DOR_ADMIN,
        Roles.MANUFACTURER_ADMIN,
        Roles.AREA_MANAGER,
        Roles.REGIONAL_MANAGER,
      ],
      exact: true,
      breadcrumb: "Cases",
      component: RMHospitalsCasePage,
    },
    {
      path: "/manufacturer/:id/area/:areaid/regional-manager/:rmid/hospital",
      rolesAccess: [
        Roles.DOR_ADMIN,
        Roles.MANUFACTURER_ADMIN,
        Roles.AREA_MANAGER,
        Roles.REGIONAL_MANAGER,
      ],
      exact: true,
      breadcrumb: "Hospitals",
      component: RMHospitalsPage,
    },
    /** EQUIPMENTS */
    {
      path: "/manufacturer/:id/area/:areaid/regional-manager/:rmid/equipment/deleted",
      rolesAccess: [
        Roles.DOR_ADMIN,
        Roles.MANUFACTURER_ADMIN,
        Roles.AREA_MANAGER,
        Roles.REGIONAL_MANAGER,
      ],
      exact: true,
      breadcrumb: "Deleted",
      component: RMEquipmentsPage,
    },
    {
      path: "/manufacturer/:id/area/:areaid/regional-manager/:rmid/equipment/new",
      rolesAccess: [
        Roles.DOR_ADMIN,
        Roles.MANUFACTURER_ADMIN,
        Roles.AREA_MANAGER,
        Roles.REGIONAL_MANAGER,
      ],
      exact: true,
      breadcrumb: "New Instrument",
      component: RMEquipmentForm,
    },
    {
      path: "/manufacturer/:id/area/:areaid/regional-manager/:rmid/equipment/:equipmentid",
      rolesAccess: [
        Roles.DOR_ADMIN,
        Roles.MANUFACTURER_ADMIN,
        Roles.AREA_MANAGER,
        Roles.REGIONAL_MANAGER,
      ],
      exact: true,
      breadcrumb: "Instrument Details",
      component: RMEquipmentForm,
    },
    {
      path: "/manufacturer/:id/area/:areaid/regional-manager/:rmid/equipment",
      rolesAccess: [
        Roles.DOR_ADMIN,
        Roles.MANUFACTURER_ADMIN,
        Roles.AREA_MANAGER,
        Roles.REGIONAL_MANAGER,
      ],
      exact: true,
      breadcrumb: "Instruments",
      component: RMEquipmentsPage,
    },
    /** TRAYS */
    {
      path: "/manufacturer/:id/area/:areaid/regional-manager/:rmid/tray/deleted",
      rolesAccess: [
        Roles.DOR_ADMIN,
        Roles.MANUFACTURER_ADMIN,
        Roles.AREA_MANAGER,
        Roles.REGIONAL_MANAGER,
      ],
      exact: true,
      breadcrumb: "Deleted",
      component: RMTraysPage,
    },
    {
      path: "/manufacturer/:id/area/:areaid/regional-manager/:rmid/tray/new",
      rolesAccess: [
        Roles.DOR_ADMIN,
        Roles.MANUFACTURER_ADMIN,
        Roles.AREA_MANAGER,
        Roles.REGIONAL_MANAGER,
      ],
      exact: true,
      breadcrumb: "New Tray",
      component: RMTrayForm,
    },
    {
      path: "/manufacturer/:id/area/:areaid/regional-manager/:rmid/tray/:trayid",
      rolesAccess: [
        Roles.DOR_ADMIN,
        Roles.MANUFACTURER_ADMIN,
        Roles.AREA_MANAGER,
        Roles.REGIONAL_MANAGER,
      ],
      exact: true,
      breadcrumb: "Tray Details",
      component: RMTrayForm,
    },
    {
      path: "/manufacturer/:id/area/:areaid/regional-manager/:rmid/tray",
      rolesAccess: [
        Roles.DOR_ADMIN,
        Roles.MANUFACTURER_ADMIN,
        Roles.AREA_MANAGER,
        Roles.REGIONAL_MANAGER,
      ],
      exact: true,
      breadcrumb: "Trays",
      component: RMTraysPage,
    },
    /** PROCEDURES */
    {
      path: "/manufacturer/:id/area/:areaid/regional-manager/:rmid/procedure",
      rolesAccess: [
        Roles.DOR_ADMIN,
        Roles.MANUFACTURER_ADMIN,
        Roles.AREA_MANAGER,
        Roles.REGIONAL_MANAGER,
      ],
      exact: true,
      breadcrumb: "Procedures",
      component: RMProceduresPage,
    },
    {
      path: "/manufacturer/:id/area/:areaid/regional-manager/:rmid/procedure-library/deleted",
      rolesAccess: [
        Roles.DOR_ADMIN,
        Roles.MANUFACTURER_ADMIN,
        Roles.AREA_MANAGER,
        Roles.REGIONAL_MANAGER,
      ],
      exact: true,
      breadcrumb: "Deleted",
      component: RMProceduresPage,
    },
    /** Medical-Representatives */
    {
      path: "/manufacturer/:id/area/:areaid/regional-manager/:rmid/medical-representative/deleted",
      rolesAccess: [
        Roles.DOR_ADMIN,
        Roles.MANUFACTURER_ADMIN,
        Roles.AREA_MANAGER,
        Roles.REGIONAL_MANAGER,
      ],
      exact: true,
      breadcrumb: "Deleted",
      component: MedicalRepresentativesPage,
    },
    {
      path: "/manufacturer/:id/area/:areaid/regional-manager/:rmid/medical-representative/new",
      rolesAccess: [
        Roles.DOR_ADMIN,
        Roles.MANUFACTURER_ADMIN,
        Roles.AREA_MANAGER,
        Roles.REGIONAL_MANAGER,
      ],
      exact: true,
      breadcrumb: "New Medical Representative",
      component: MedicalRepresentativeForm,
    },
    // For Breadcrumb
    {
      path: "/manufacturer/:id/area/:areaid/regional-manager/:rmid/medical-representative/:mmrid",
      rolesAccess: [
        Roles.DOR_ADMIN,
        Roles.MANUFACTURER_ADMIN,
        Roles.AREA_MANAGER,
        Roles.REGIONAL_MANAGER,
        Roles.MMR,
      ],
      exact: true,
      breadcrumb: (props) => (
        <BreadCrumbData type="user" id={props.match.params.mmrid} />
      ),
      redirection: "setup",
    },
    {
      path: "/manufacturer/:id/area/:areaid/regional-manager/:rmid/medical-representative",
      rolesAccess: [
        Roles.DOR_ADMIN,
        Roles.MANUFACTURER_ADMIN,
        Roles.AREA_MANAGER,
        Roles.REGIONAL_MANAGER,
      ],
      exact: true,
      breadcrumb: "Medical Representatives",
      component: MedicalRepresentativesPage,
    },
    /** Manufacturer Regional Managers MR End */
  ],
  MiniAppRoutes: [
    {
      path: "/manufacturer/:id/area/:areaid/regional-manager/:rmid/procedure/new",
      rolesAccess: [
        Roles.DOR_ADMIN,
        Roles.MANUFACTURER_ADMIN,
        Roles.AREA_MANAGER,
        Roles.REGIONAL_MANAGER,
      ],
      exact: true,
      breadcrumb: "New Procedure",
      component: RMProcedureForm,
    },
    {
      path: "/manufacturer/:id/area/:areaid/regional-manager/:rmid/procedure/:procedureid",
      rolesAccess: [
        Roles.DOR_ADMIN,
        Roles.MANUFACTURER_ADMIN,
        Roles.AREA_MANAGER,
        Roles.REGIONAL_MANAGER,
      ],
      exact: true,
      breadcrumb: "Procedure Details",
      component: RMProcedureForm,
    },
    {
      path: "/manufacturer/:id/area/:areaid/regional-manager/:rmid/procedure/:procedureid/table-setup",
      rolesAccess: [
        Roles.DOR_ADMIN,
        Roles.MANUFACTURER_ADMIN,
        Roles.AREA_MANAGER,
        Roles.REGIONAL_MANAGER,
      ],
      exact: true,
      component: RMTableSetup,
    },
    {
      path: "/manufacturer/:id/area/:areaid/regional-manager/:rmid/procedure/:procedureid/tray-management",
      rolesAccess: [
        Roles.DOR_ADMIN,
        Roles.MANUFACTURER_ADMIN,
        Roles.AREA_MANAGER,
        Roles.REGIONAL_MANAGER,
      ],
      exact: true,
      component: RMTrayEquipmentPage,
    },
    {
      path: "/manufacturer/:id/area/:areaid/regional-manager/:rmid/procedure/:procedureid/execution-flow/new",
      rolesAccess: [
        Roles.DOR_ADMIN,
        Roles.MANUFACTURER_ADMIN,
        Roles.AREA_MANAGER,
        Roles.REGIONAL_MANAGER,
      ],
      exact: true,
      component: RMExecutionFlowPage,
    },
    {
      path: "/manufacturer/:id/area/:areaid/regional-manager/:rmid/procedure/:procedureid/execution-flow/edit",
      rolesAccess: [
        Roles.DOR_ADMIN,
        Roles.MANUFACTURER_ADMIN,
        Roles.AREA_MANAGER,
        Roles.REGIONAL_MANAGER,
      ],
      exact: true,
      component: RMExecutionFlowPage, //ReadOnly
    },
    /** ReadOnly Hospital Case Procedure */
    {
      path: "/manufacturer/:id/area/:areaid/regional-manager/:rmid/hospital/:hospitalid/case/:caseid/procedure/:procedureid/table-setup",
      rolesAccess: [
        Roles.DOR_ADMIN,
        Roles.MANUFACTURER_ADMIN,
        Roles.AREA_MANAGER,
        Roles.REGIONAL_MANAGER,
      ],
      exact: true,
      component: ProcedureMainPage,
    },
    {
      path: "/manufacturer/:id/area/:areaid/regional-manager/:rmid/hospital/:hospitalid/case/:caseid/procedure/:procedureid/execution-flow/edit",
      rolesAccess: [
        Roles.DOR_ADMIN,
        Roles.MANUFACTURER_ADMIN,
        Roles.AREA_MANAGER,
        Roles.REGIONAL_MANAGER,
      ],
      exact: true,
      component: ExecutionFlow,
    },
    /** ReadOnly Hospital Live Case */
    {
      path: "/manufacturer/:id/area/:areaid/regional-manager/:rmid/hospital/:hospitalid/case/:caseid/live-case",
      rolesAccess: [
        Roles.DOR_ADMIN,
        Roles.MANUFACTURER_ADMIN,
        Roles.AREA_MANAGER,
        Roles.REGIONAL_MANAGER,
      ],
      exact: true,
      component: LiveCaseMainPage,
    },
  ],
};

export default regionalManagerRoutes;
